// extracted by mini-css-extract-plugin
export default {"item_type":"AddValues_item_type__N+4QC"};